'use strict';

class CRadioButtonController{
  constructor(){
    'ngInject';
  }
  $onInit(){

  }
  controlCambioValor(valor) {
    if(this.ngChange && typeof this.ngChange === 'function'){
      this.ngChange({data: valor});
    }
  }
}
export default CRadioButtonController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-radiobutton/c-radiobutton.controller.js